import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetMyEventList = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const sortBy = searchParams.get('sortBy')
	const sortDirection = searchParams.get('sortDirection')
	const [userRole] = useRoleCookie()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let path = `/${rolePath}/event/my/list?page=${page}`
		if (search) path += `&search=${search}`
		if (sortBy) path += `&sortBy=${sortBy}`
		if (sortDirection) path += `&sortDirection=${sortDirection}`
		fetchRequest('GET', path)
	}, [page, search, sortBy, sortDirection])

	return [fetchResult, isLoading]
}

export default useGetMyEventList
